import styled from "styled-components";

export const Main = styled.div`
   display: flex;
   flex-direction: column;
   justify-content: center;
   width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
   .disabled {
      opacity: 0.65;
      pointer-events: none;
   }
   .action {
      position: relative;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      align-items: center;
      padding-bottom: 10px;
      margin-bottom: 11px;

      &::after {
         content: '';
         position: absolute;
         left: 0;
         bottom: 0;
         width: 100%;
         height: 0.5px;
         background-color: rgb(220, 220, 220);
      }
      .btn1 {
         width: calc(100% / 3 - 5px);
         margin-top: 3px;

         .line {
            margin-bottom: 0;
            &::after { display: none; }
         }
         &.withBorder.delete {
            margin-left: 0;
         }
         &.website {
            width: 100%;
            margin-top: 7.5px;
         }
      }
   } 
   .profile_template {
      margin-bottom: 10px;
      h4 {
         width: 70px;
      }
   }
   .scroll {
      padding-top: 10px;
      overflow: auto;
      max-height: 280px;

      /* textarea {
         width: 100% !important;
         min-height: 80px;
         max-height: 125px;
         padding: 7.5px 15px;
         font-size: 16px;
      } */
      .textarea {
         > div {
            height: 100px;
            max-width: 100px;
            min-height: 100px;
         }
      }
   }
   .item {
      position: relative;
      padding: 15px 10px;
      border: 1px solid rgb(220, 220, 220);
      border-radius: 5px;

      .title {
         position: absolute;
         top: -11px;
         left: 15px;
         background-color: #fff;
         z-index: 99;
         font-size: 15px;
         cursor: pointer;
         padding: 0 7.5px;

         span, svg {
            opacity: 0.65;
            transition: all .2s ease-in-out;
         }
         svg {
            position: relative;
            top: 1.5px;
            margin-right: 7.5px;
         }
         &:hover {
            span, svg {
               opacity: 1;
            }
         }
      }
      &:not(:last-of-type) {
         margin-bottom: 15px;
      }
      > .textInput {
         h4 {
            width: 100px;
         }
         &:not(:last-of-type) {
            margin-bottom: 10px;
         }
      }
      .timer {
         .textInput h4 {
            width: 100px;
         }
         .textInput:first-of-type {
            border-bottom: none;
            input {
               border-bottom-left-radius: 0;
               border-bottom-right-radius: 0;
            }
         }
         .textInput:last-of-type input {
            border-top-left-radius: 0;
            border-top-right-radius: 0;
         }
      }
      .switch {
         margin-top: 15px;
      }
      .remove {
         position: absolute;
         right: 15px;
         bottom: 10px;
         display: flex;
         align-items: center;
         justify-content: center;
         background-color: #F6F6F6;
         color: #E02424;
         border: 1px solid rgb(220, 220, 220);
         border-radius: 5px;
         width: 40.2px;
         height: 30px;
         margin-left: 7.5px;
         cursor: pointer;
         transition: all .2s ease-in-out;
         
         svg {
            opacity: 0.65;
         }
         &:hover {
            background-color: #E02424;
            color: #fff;

            svg {
               opacity: 1;
            }
         }
      }
   }
   .instance {
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: absolute;
      top: -5px;
      left: calc(100% + 23px);
      margin-top: -30px;
      background-color: #fff;
      width: 100%;
      // height: 100%;

      &::before {
         content: '';
         position: absolute;
         left: -24px;
         width: 24px;
         height: 1px;
         background-color: #b1b1b7;
         z-index: 99;
      }
      > .title {
         position: relative;
         display: flex;
         justify-content: space-between;
         align-items: center;
         background-color: #cee5fd;
         padding: 5px 7.5px;
         height: 30px;
         font-size: 16px;
         font-weight: 400;
         border: 1px solid rgb(220, 220, 220);
         border-radius: 5px 5px 0 0;
      }
      > div {
         padding: 15px;
         border: 1px solid rgb(220, 220, 220);
         border-top: none;
         border-radius: 0 0 5px 5px;
      }
      &.website {
         min-width: 100%;
         width: auto;
         
         span:first-of-type {
            display: block;
            margin-bottom: 7.5px;
            opacity: 0.65;
         }
         textarea {
            padding: 15px;
         }
      }
   }
`;